/**
 * Safe string utility functions for defensive programming
 * Prevents "Cannot read properties of undefined" errors
 */

/**
 * Safely converts a string to uppercase, returns empty string if input is null/undefined
 */
export const safeUpperCase = (str?: string | null): string => {
  return str ? str.toUpperCase() : '';
};

/**
 * Safely converts a string to lowercase, returns empty string if input is null/undefined
 */
export const safeLowerCase = (str?: string | null): string => {
  return str ? str.toLowerCase() : '';
};

/**
 * Safely checks if a string includes a substring, returns false if input is null/undefined
 */
export const safeIncludes = (str: string | null | undefined, search: string): boolean => {
  return str ? str.includes(search) : false;
};

/**
 * Safely returns an array, providing empty array fallback for null/undefined
 */
export const safeArray = <T>(arr?: T[] | null): T[] => {
  return Array.isArray(arr) ? arr : [];
};

/**
 * Safely gets a string value, providing fallback for null/undefined
 */
export const safeString = (str?: string | null, fallback: string = ''): string => {
  return str ?? fallback;
};

/**
 * Safely gets a number value, providing fallback for null/undefined
 */
export const safeNumber = (num?: number | null, fallback: number = 0): number => {
  return num ?? fallback;
};

/**
 * Type guard to check if a value is a non-empty string
 */
export const isNonEmptyString = (value?: string | null): value is string => {
  return typeof value === 'string' && value.length > 0;
};